export default "__VITE_ASSET__C_GEY6wE__"